export default {"src":"https://s.sylndr.com/c-36057ae/_next/static/media/sylndrLogo.f53a9108.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};